// removed by extract-text-webpack-plugin
module.exports = {"accordion":"accordion__LCFtq","accordion-section":"accordion-section__3fRkS","radio-highlight":"radio-highlight__3se95","accordion-title":"accordion-title__2ogz_","body":"body__2qObC","selected":"selected__1wJp4","custom":"custom__ECkWP"};


//////////////////
// WEBPACK FOOTER
// ./styles/accordian.scss
// module id = 80
// module chunks = 68